// Regulamin — mamy!kongres

export const ORGANIZER = {
  name: "Fundacja Priorytety",
  addressLines: ["ul. Cecylii Śniegockiej 2/34", "00-430 Warszawa"],
  nip: "7011023132",
  krs: "0000886132",
  email: "biuro@fundacjapriorytety.pl",
  phone: "+48 503 017 919",
  eventDate: "22 maja 2027 r.",
  eventVenue: "ul. Wybrzeże Kościuszkowskie 37, 00–379 Warszawa",
};

// Each item can be:
//   { p: "paragraph text" }
//   { p: "intro to list", list: ["...", "..."] }
//   { list: ["..."] }
export const REGULATIONS = [
  {
    n: 1,
    title: "Postanowienia ogólne",
    items: [
      { p: "Niniejszy Regulamin określa zasady zakupu biletów, rejestracji oraz uczestnictwa w wydarzeniu pod nazwą „Mamy Kongres”, zwanym dalej „Kongresem” lub „Wydarzeniem”." },
      { p: "Organizatorem Kongresu jest Fundacja Priorytety, ul. Cecylii Śniegockiej 2/34, 00-430 Warszawa, NIP: 7011023132, KRS: 0000886132, zwana dalej „Organizatorem”." },
      { p: "Kongres odbędzie się 22 maja 2027 r. w Warszawie, przy ul. Wybrzeże Kościuszkowskie 37, 00–379 Warszawa." },
      { p: "Szczegółowe godziny rozpoczęcia i zakończenia Kongresu zostaną podane na stronie internetowej wydarzenia oraz w komunikacji kierowanej do osób, które zakupiły bilety." },
      { p: "Szczegółowy program Kongresu, lista prelegentek i prelegentów, kolejność wystąpień oraz informacje organizacyjne mogą być publikowane i aktualizowane na stronie internetowej Kongresu." },
      { p: "Organizator zastrzega możliwość dokonywania zmian w programie, harmonogramie oraz składzie prelegentek i prelegentów, zgodnie z zasadami określonymi w niniejszym Regulaminie." },
    ],
  },
  {
    n: 2,
    title: "Definicje",
    items: [
      { list: [
        "Organizator – Fundacja Priorytety.",
        "Kongres / Wydarzenie – wydarzenie pod nazwą „Mamy Kongres”, organizowane 22 maja 2027 r. w Warszawie.",
        "Uczestnik – osoba fizyczna uprawniona do udziału w Kongresie na podstawie zakupionego biletu.",
        "Kupujący – osoba fizyczna lub podmiot dokonujący zakupu biletu.",
        "Bilet – elektroniczny dokument potwierdzający prawo jednej osoby do udziału w Kongresie.",
        "Sklep – internetowy system sprzedaży biletów prowadzony przez Organizatora.",
        "Early Bird – pula biletów oferowana w promocyjnej cenie od 22 lutego 2027 r. do dnia 22 marca 2027 r. włącznie lub do wcześniejszego wyczerpania tej puli.",
        "Bilet Standard – bilet sprzedawany po zakończeniu sprzedaży Early Bird, w cenie wskazanej w Sklepie.",
        "Regulamin – niniejszy dokument.",
      ] },
    ],
  },
  {
    n: 3,
    title: "Sprzedaż biletów",
    items: [
      { p: "Sprzedaż biletów na Kongres odbywa się za pośrednictwem internetowego Sklepu Organizatora." },
      { p: "Organizator przewiduje co najmniej dwie pule biletów:", list: [
        "Early Bird – dostępne od 22 lutego 2027 r. do 22 marca 2027 r. lub do wyczerpania puli;",
        "Standard – dostępne po zakończeniu sprzedaży Early Bird.",
      ] },
      { p: "Organizator może ustalić ograniczoną liczbę biletów dostępnych w poszczególnych pulach." },
      { p: "O dostępności konkretnej puli oraz jej cenie decydują informacje prezentowane w Sklepie w momencie zakupu." },
      { p: "Organizator może wprowadzać dodatkowe rodzaje biletów, pakiety, promocje lub akcje specjalne." },
      { p: "Wszystkie ceny podane w Sklepie są cenami brutto, chyba że wyraźnie wskazano inaczej." },
      { p: "Bilet uprawnia do udziału w Kongresie zgodnie z zakresem świadczeń przypisanym do danego rodzaju biletu." },
    ],
  },
  {
    n: 4,
    title: "Zawarcie umowy i zakup biletu",
    items: [
      { p: "Zakupu biletu może dokonać osoba fizyczna, przedsiębiorca, osoba prawna lub inny podmiot posiadający zdolność do zawierania umów." },
      { p: "W celu dokonania zakupu Kupujący podaje dane wymagane w formularzu zamówienia." },
      { p: "Kupujący zobowiązany jest do podania danych prawdziwych i aktualnych." },
      { p: "Przed dokonaniem zakupu Kupujący ma możliwość zapoznania się z:", list: [
        "ceną biletu;",
        "jego rodzajem;",
        "niniejszym Regulaminem;",
        "informacjami dotyczącymi Kongresu;",
        "informacjami dotyczącymi przetwarzania danych osobowych.",
      ] },
      { p: "Zawarcie umowy następuje poprzez prawidłowe złożenie zamówienia i dokonanie płatności." },
      { p: "Po zaksięgowaniu płatności Kupujący otrzymuje potwierdzenie zakupu oraz bilet w formie elektronicznej na wskazany adres e-mail." },
      { p: "Kupujący jest odpowiedzialny za prawidłowość podanego adresu e-mail." },
    ],
  },
  {
    n: 5,
    title: "Płatności",
    items: [
      { p: "Płatność za bilet odbywa się za pośrednictwem metod płatności dostępnych w Sklepie." },
      { p: "Za moment dokonania płatności uważa się moment potwierdzenia prawidłowego wykonania płatności przez operatora płatności." },
      { p: "W przypadku nieudanej płatności zamówienie może zostać anulowane." },
      { p: "W przypadku anulowania nieopłaconego zamówienia bilet może zostać ponownie udostępniony do sprzedaży." },
      { p: "Organizator nie odpowiada za opóźnienia płatności wynikające z działania banku, operatora płatności lub innych podmiotów, za które Organizator nie ponosi odpowiedzialności." },
    ],
  },
  {
    n: 6,
    title: "Faktury",
    items: [
      { p: "Kupujący może otrzymać fakturę zgodnie z obowiązującymi przepisami prawa." },
      { p: "W przypadku zakupu na rzecz firmy lub innego podmiotu Kupujący powinien podać prawidłowe dane niezbędne do wystawienia faktury." },
      { p: "Organizator nie odpowiada za błędy w danych wynikające z informacji podanych przez Kupującego." },
    ],
  },
  {
    n: 7,
    title: "Bilet i prawo wstępu",
    items: [
      { p: "Jeden bilet uprawnia do udziału w Kongresie jednej osoby." },
      { p: "Bilet może zostać okazany w formie elektronicznej." },
      { p: "Przy wejściu Organizator lub obsługa Kongresu może zweryfikować ważność biletu." },
      { p: "Organizator może odmówić wstępu osobie posługującej się biletem:", list: [
        "nieważnym;",
        "wcześniej wykorzystanym;",
        "uzyskanym w sposób niezgodny z Regulaminem;",
        "którego autentyczność budzi uzasadnione wątpliwości.",
      ] },
      { p: "Zabronione jest kopiowanie biletów oraz posługiwanie się kopią biletu przez więcej niż jedną osobę." },
    ],
  },
  {
    n: 8,
    title: "Zmiana osoby uczestniczącej",
    items: [
      { p: "Organizator umożliwia zmianę osoby, która będzie uczestniczyć w Kongresie." },
      { p: "Zmiana osoby uczestniczącej jest bezpłatna." },
      { p: "W celu dokonania zmiany należy skontaktować się z Organizatorem pod adresem: biuro@fundacjapriorytety.pl" },
      { p: "Zgłoszenie powinno zawierać:", list: [
        "numer zamówienia lub biletu;",
        "dane dotychczasowej osoby uczestniczącej;",
        "dane nowej osoby;",
        "adres e-mail nowej osoby.",
      ] },
      { p: "Organizator może określić termin graniczny dokonywania zmian, jeżeli jest to konieczne ze względów organizacyjnych, w szczególności związanych z przygotowaniem list uczestników, identyfikatorów lub materiałów." },
      { p: "Zmiana osoby uczestniczącej nie powoduje zmiany rodzaju biletu." },
      { p: "Bilet zakupiony w ramach Early Bird zachowuje warunki cenowe wynikające z pierwotnego zakupu." },
      { p: "Przekazanie biletu innej osobie nie może być podstawą do żądania dopłaty do aktualnej ceny biletu Standard." },
    ],
  },
  {
    n: 9,
    title: "Rezygnacja i polityka zwrotów",
    items: [
      { p: "Ze względu na charakter Kongresu oraz jego konkretnie oznaczony termin – 22 maja 2027 r. – do umowy dotyczącej udziału w Kongresie stosuje się wyjątek od prawa odstąpienia od umowy zawartej na odległość przewidziany w art. 38 pkt 12 ustawy o prawach konsumenta. UOKiK wskazuje wprost, że wyjątek ten obejmuje usługi związane z wydarzeniami rozrywkowymi, sportowymi lub kulturalnymi, jeżeli w umowie oznaczono dzień lub okres świadczenia, w tym zakup biletu na koncert." },
      { p: "W związku z powyższym Kupującemu nie przysługuje ustawowe 14-dniowe prawo odstąpienia od umowy wyłącznie z powodu zakupu biletu przez internet." },
      { p: "Organizator nie przewiduje dobrowolnych zwrotów biletów w przypadku:", list: [
        "zmiany planów przez Uczestnika;",
        "rezygnacji z udziału;",
        "choroby lub innych przyczyn osobistych Uczestnika, z zastrzeżeniem bezwzględnie obowiązujących przepisów prawa;",
        "niemożności przyjazdu na Kongres;",
        "spóźnienia na Kongres;",
        "wcześniejszego opuszczenia Kongresu.",
      ] },
      { p: "W przypadku braku możliwości udziału Uczestnik może skorzystać z możliwości bezpłatnej zmiany osoby uczestniczącej, zgodnie z punktem 8." },
      { p: "Niniejsze postanowienia nie wyłączają ani nie ograniczają praw Kupującego wynikających z bezwzględnie obowiązujących przepisów prawa." },
      { p: "W szczególności w przypadku odwołania Kongresu przez Organizatora lub istotnej zmiany warunków wydarzenia zastosowanie mają postanowienia punktu 10." },
      { p: "Organizator nie zwraca kosztów dodatkowych poniesionych przez Uczestnika w związku z udziałem w Kongresie, w szczególności kosztów transportu, noclegu, parkingu czy innych usług, chyba że obowiązek ich zwrotu wynika z bezwzględnie obowiązujących przepisów prawa." },
    ],
  },
  {
    n: 10,
    title: "Odwołanie lub zmiana terminu Kongresu",
    items: [
      { p: "Organizator dołoży należytej staranności, aby Kongres odbył się w zaplanowanym terminie i miejscu." },
      { p: "Z ważnych przyczyn Organizator może zmienić termin, miejsce, godziny lub program Kongresu." },
      { p: "O istotnych zmianach Organizator poinformuje Uczestników za pośrednictwem adresu e-mail podanego przy zakupie biletu lub poprzez stronę internetową Kongresu." },
      { p: "W przypadku zmiany terminu Organizator poinformuje Uczestników o:", list: [
        "nowym terminie;",
        "zasadach wykorzystania zakupionych biletów;",
        "ewentualnych uprawnieniach do zwrotu środków wynikających z obowiązujących przepisów prawa.",
      ] },
      { p: "W przypadku odwołania Kongresu Organizator poinformuje Uczestników o dalszym sposobie postępowania." },
      { p: "Jeżeli zgodnie z obowiązującymi przepisami prawa lub warunkami przedstawionymi przez Organizatora Kupującemu przysługuje zwrot ceny biletu, Organizator dokona takiego zwrotu." },
      { p: "Zwrot zostanie dokonany przy użyciu sposobu płatności wykorzystanego podczas zakupu, chyba że przepisy prawa lub uzgodnienie z Kupującym przewidują inną dopuszczalną formę." },
    ],
  },
  {
    n: 11,
    title: "Program i prelegentki",
    items: [
      { p: "Program Kongresu oraz lista prelegentek i prelegentów mogą być sukcesywnie publikowane na stronie internetowej Kongresu." },
      { p: "Organizator zastrzega możliwość zmiany programu, kolejności wystąpień, godzin poszczególnych punktów programu oraz składu prelegentek i prelegentów." },
      { p: "Zmiany mogą wynikać w szczególności z przyczyn organizacyjnych, losowych, technicznych lub innych przyczyn niezależnych od Organizatora." },
      { p: "Zmiana pojedynczej prelegentki lub prelegenta nie powoduje automatycznie prawa do zwrotu ceny biletu." },
      { p: "Jeżeli zmiana wydarzenia będzie miała charakter istotny i na podstawie obowiązujących przepisów prawa Kupującemu będzie przysługiwało określone uprawnienie, Organizator poinformuje o nim Uczestników." },
    ],
  },
  {
    n: 12,
    title: "Zasady uczestnictwa",
    items: [
      { p: "Uczestnicy są zobowiązani do przestrzegania zasad bezpieczeństwa oraz poleceń Organizatora i obsługi Kongresu." },
      { p: "Podczas Kongresu zabronione jest w szczególności:", list: [
        "zachowanie zagrażające bezpieczeństwu innych osób;",
        "niszczenie wyposażenia obiektu;",
        "zakłócanie przebiegu wydarzenia;",
        "naruszanie praw innych uczestników;",
        "wnoszenie przedmiotów zabronionych przepisami prawa lub zasadami obowiązującymi w miejscu wydarzenia.",
      ] },
      { p: "Organizator może podjąć odpowiednie działania wobec osoby rażąco naruszającej zasady bezpieczeństwa lub porządek wydarzenia, z poszanowaniem praw tej osoby wynikających z obowiązujących przepisów." },
    ],
  },
  {
    n: 13,
    title: "Fotografie, nagrania i wizerunek",
    items: [
      { p: "W trakcie Kongresu mogą być wykonywane fotografie oraz nagrania audio i wideo." },
      { p: "Materiały mogą być wykorzystywane do:", list: [
        "dokumentowania przebiegu Kongresu;",
        "relacjonowania wydarzenia;",
        "promocji działalności Fundacji Priorytety;",
        "promocji kolejnych wydarzeń organizowanych przez Fundację.",
      ] },
      { p: "Materiały mogą być publikowane w szczególności na stronie internetowej Fundacji i Kongresu, w mediach społecznościowych oraz materiałach informacyjnych i promocyjnych." },
      { p: "Organizator będzie respektował prawa osób, których wizerunek został utrwalony, zgodnie z obowiązującymi przepisami prawa." },
      { p: "Jeżeli wykorzystanie wizerunku konkretnej osoby będzie wymagało uzyskania odrębnej zgody, Organizator uzyska taką zgodę w odpowiedni sposób." },
    ],
  },
  {
    n: 14,
    title: "Dane osobowe",
    items: [
      { p: "Administratorem danych osobowych jest Fundacja Priorytety, ul. Cecylii Śniegockiej 2/34, 00-430 Warszawa." },
      { p: "Dane osobowe są przetwarzane w szczególności w celu:", list: [
        "obsługi zamówienia;",
        "sprzedaży i realizacji biletu;",
        "organizacji Kongresu;",
        "kontaktu z Uczestnikiem w sprawach organizacyjnych;",
        "obsługi płatności;",
        "wystawiania dokumentów księgowych;",
        "rozpatrywania reklamacji;",
        "realizacji obowiązków prawnych;",
        "dochodzenia lub obrony przed roszczeniami.",
      ] },
      { p: "Podanie danych niezbędnych do realizacji zakupu jest konieczne do zawarcia i wykonania umowy." },
      { p: "Przetwarzanie danych niezbędnych do realizacji zakupu nie jest uzależnione od wyrażenia zgody marketingowej." },
      { p: "Szczegółowe informacje dotyczące zasad przetwarzania danych osobowych, podstaw prawnych, okresów przechowywania danych oraz praw osób, których dane dotyczą, znajdują się w Polityce Prywatności Organizatora." },
      { p: "Uczestnikowi przysługują prawa wynikające z obowiązujących przepisów o ochronie danych osobowych, w tym prawa dotyczące dostępu do danych, ich sprostowania, ograniczenia przetwarzania, usunięcia danych w przypadkach przewidzianych prawem oraz wniesienia sprzeciwu." },
    ],
  },
  {
    n: 15,
    title: "Zgody marketingowe",
    items: [
      { p: "Organizator może przesyłać Uczestnikom informacje marketingowe dotyczące wydarzeń, projektów, inicjatyw i działalności Fundacji Priorytety, jeżeli Uczestnik udzielił w tym zakresie wymaganej zgody." },
      { p: "Zgoda marketingowa jest dobrowolna i nie jest warunkiem zakupu biletu." },
      { p: "Zgoda marketingowa powinna być udzielona poprzez odrębne zaznaczenie odpowiedniego pola w formularzu zakupu lub w innym kanale komunikacji." },
      { p: "Uczestnik może w dowolnym momencie wycofać zgodę marketingową. Wycofanie zgody powinno być możliwe w sposób równie łatwy jak jej udzielenie." },
      { p: "Wycofanie zgody marketingowej nie wpływa na zgodność z prawem przetwarzania dokonanego przed jej wycofaniem." },
      { p: "Wycofanie zgody marketingowej nie powoduje zaprzestania przesyłania wiadomości niezbędnych do realizacji zakupionego biletu i organizacji Kongresu." },
    ],
  },
  {
    n: 16,
    title: "Checkboxy przy zakupie biletu",
    items: [
      { p: "W formularzu zakupu biletu Organizator stosuje następujące pola:" },
      { checkbox: { label: "Pole obowiązkowe", text: "Akceptuję Regulamin Mamy Kongres i potwierdzam, że zapoznałam/em się z zasadami zakupu biletów, uczestnictwa w wydarzeniu oraz polityką zwrotów." } },
      { checkbox: { label: "Pole obowiązkowe / informacyjne", text: "Zapoznałam/em się z informacją o przetwarzaniu moich danych osobowych przez Fundację Priorytety w związku z zakupem biletu i organizacją Mamy Kongres. Szczegółowe informacje znajdują się w Polityce Prywatności." } },
      { checkbox: { label: "Pole dobrowolne — marketing", text: "Chcę otrzymywać informacje marketingowe od Fundacji Priorytety dotyczące wydarzeń, projektów i innych działań Fundacji drogą elektroniczną. Wiem, że mogę wycofać tę zgodę w dowolnym momencie." } },
      { p: "Pole dotyczące komunikacji marketingowej nie może być zaznaczone domyślnie." },
      { p: "Brak zgody marketingowej nie może uniemożliwiać zakupu biletu ani udziału w Kongresie." },
      { p: "Zgoda marketingowa powinna być możliwa do wycofania w sposób łatwy i niepowodujący negatywnych konsekwencji dla Uczestnika. UODO wskazuje, że zgoda musi być dobrowolna, a jej wycofanie powinno być równie łatwe jak jej udzielenie." },
    ],
  },
  {
    n: 17,
    title: "Reklamacje",
    items: [
      { p: "Kupujący lub Uczestnik może złożyć reklamację dotyczącą zakupu biletu, działania Sklepu lub organizacji Kongresu." },
      { p: "Reklamację można przesłać na adres: biuro@fundacjapriorytety.pl lub na adres siedziby Organizatora." },
      { p: "Reklamacja powinna w miarę możliwości zawierać:", list: [
        "imię i nazwisko lub nazwę Kupującego;",
        "numer zamówienia lub biletu;",
        "opis problemu;",
        "oczekiwany sposób rozwiązania sprawy;",
        "dane kontaktowe.",
      ] },
      { p: "Organizator rozpatruje reklamację w terminie wynikającym z obowiązujących przepisów prawa." },
      { p: "Odpowiedź na reklamację zostanie przekazana na adres e-mail wskazany przez osobę składającą reklamację, chyba że uzgodniono inną formę." },
    ],
  },
  {
    n: 18,
    title: "Odpowiedzialność",
    items: [
      { p: "Organizator zobowiązuje się do organizacji Kongresu z należytą starannością." },
      { p: "Organizator nie ponosi odpowiedzialności za okoliczności, za które nie ponosi odpowiedzialności na podstawie obowiązujących przepisów prawa." },
      { p: "Organizator nie odpowiada za rzeczy pozostawione przez Uczestników na terenie miejsca wydarzenia, z zastrzeżeniem odpowiedzialności wynikającej z obowiązujących przepisów." },
      { p: "Uczestnik ponosi odpowiedzialność za szkody wyrządzone przez siebie Organizatorowi, obiektowi lub osobom trzecim na zasadach określonych w przepisach prawa." },
    ],
  },
  {
    n: 19,
    title: "Postanowienia dotyczące konsumentów",
    items: [
      { p: "Żadne postanowienie Regulaminu nie ma na celu wyłączenia ani ograniczenia praw konsumentów wynikających z bezwzględnie obowiązujących przepisów prawa." },
      { p: "Jeżeli którekolwiek postanowienie Regulaminu okaże się mniej korzystne dla konsumenta niż przepisy prawa, zastosowanie mają przepisy prawa." },
      { p: "W przypadku przedsiębiorcy będącego osobą fizyczną zastosowanie mogą mieć przepisy dotyczące ochrony konsumentów, jeżeli spełnione są ustawowe przesłanki." },
    ],
  },
  {
    n: 20,
    title: "Zmiany Regulaminu",
    items: [
      { p: "Organizator może zmienić Regulamin z ważnych przyczyn, w szczególności w przypadku:", list: [
        "zmiany przepisów prawa;",
        "zmiany sposobu organizacji Kongresu;",
        "zmiany sposobu sprzedaży biletów;",
        "konieczności doprecyzowania postanowień Regulaminu.",
      ] },
      { p: "Zmiany Regulaminu nie naruszają praw nabytych przez osoby, które dokonały zakupu biletu przed wejściem zmian w życie, chyba że zmiana wynika z bezwzględnie obowiązujących przepisów prawa." },
      { p: "Aktualna wersja Regulaminu będzie dostępna na stronie internetowej Kongresu." },
    ],
  },
  {
    n: 21,
    title: "Postanowienia końcowe",
    items: [
      { p: "Regulamin wchodzi w życie z dniem publikacji." },
      { p: "W sprawach nieuregulowanych niniejszym Regulaminem zastosowanie mają przepisy prawa polskiego." },
      { p: "Kontakt z Organizatorem możliwy jest poprzez: Fundacja Priorytety, ul. Cecylii Śniegockiej 2/34, 00-430 Warszawa, e-mail: biuro@fundacjapriorytety.pl, telefon: +48 503 017 919." },
      { p: "Regulamin jest udostępniany nieodpłatnie na stronie internetowej Kongresu w sposób umożliwiający jego zapisanie, odtworzenie i zachowanie." },
      { p: "W przypadku sprzeczności postanowień Regulaminu z bezwzględnie obowiązującymi przepisami prawa pierwszeństwo mają przepisy prawa." },
    ],
  },
];
